// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: OzMUV8kmkL
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicGreenButton.module.css"; // plasmic-import: OzMUV8kmkL/css

createPlasmicElementProxy;

export const PlasmicGreenButton__VariantProps = new Array();

export const PlasmicGreenButton__ArgProps = new Array();

const $$ = {};

function PlasmicGreenButton__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <PlasmicLink__
      data-plasmic-name={"greenButton"}
      data-plasmic-override={overrides.greenButton}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.a,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.greenButton
      )}
      href={`/global-rankings`}
      platform={"react"}
    >
      <div
        data-plasmic-name={"text"}
        data-plasmic-override={overrides.text}
        className={classNames(projectcss.all, projectcss.__wab_text, sty.text)}
      >
        {"Explore Our Index"}
      </div>
    </PlasmicLink__>
  );
}

const PlasmicDescendants = {
  greenButton: ["greenButton", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicGreenButton__ArgProps,
          internalVariantPropNames: PlasmicGreenButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicGreenButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "greenButton") {
    func.displayName = "PlasmicGreenButton";
  } else {
    func.displayName = `PlasmicGreenButton.${nodeName}`;
  }
  return func;
}

export const PlasmicGreenButton = Object.assign(
  // Top-level PlasmicGreenButton renders the root element
  makeNodeComponent("greenButton"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicGreenButton
    internalVariantProps: PlasmicGreenButton__VariantProps,
    internalArgProps: PlasmicGreenButton__ArgProps
  }
);

export default PlasmicGreenButton;
/* prettier-ignore-end */
